import React, { Fragment } from 'react';
import { i18n } from '@lingui/core';
import PropTypes from 'prop-types';
import { LegendIconRenderer } from '../LegendIconRenderer';

/**
 * ColoredItemsLegend - Легенда со списком элементов с цветами
 * Используется для: POI, New Buildings, Parking Statuses и т.д.
 */
export const ColoredItemsLegend = ({ items, icon, renderConfig }) => {
    const { showIcon, iconOpacity, fontSize, description, iconSizes = {} } = renderConfig;
    // Размеры по типам иконок: круг 10px, остальные 16px
    const iconSizeMap = {
        circle: '10px',
        hexagon: '16px',
        rect: '16px',
        line: '16px',
        default: '12px',
        ...iconSizes,
    };
    const currentIconSize = iconSizeMap[icon] || iconSizeMap.default;

    return (
        <>
            <div style={{ display: 'grid', gridTemplateColumns: currentIconSize + ' 1fr', columnGap: '12px', rowGap: '8px', alignItems: 'center', paddingLeft: '10px' }}>
                {items.map(item => (
                    <React.Fragment key={item.id || item.value || item.color || item.fill}>
                        {showIcon && (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: currentIconSize, height: currentIconSize, flexShrink: 0 }}>
                                <LegendIconRenderer
                                    type={icon}
                                    color={item.color || item.fill}
                                    size="100%"
                                    opacity={iconOpacity}
                                />
                            </div>
                        )}
                        {/* hint — развёрнутое пояснение пункта, всплывает при наведении */}
                        <p
                            title={item.hint ? i18n._(item.hint) : null}
                            style={{ fontSize, margin: '0', overflow: 'visible', wordBreak: 'break-word', lineHeight: '1.4', cursor: item.hint ? 'help' : 'auto' }}
                        >
                            {i18n._(item.label)}
                            {item.description && (
                                <span style={{ fontSize: '0.8em', opacity: 0.7, marginLeft: '8px' }}>
                                    {i18n._(item.description)}
                                </span>
                            )}
                        </p>
                    </React.Fragment>
                ))}
            </div>
            {description && (
                <div style={{ padding: '10px' }}>
                    {description}
                </div>
            )}
        </>
    );
};

ColoredItemsLegend.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.object.isRequired,
        color: PropTypes.string,
        fill: PropTypes.string,
        description: PropTypes.object,
    })).isRequired,
    icon: PropTypes.string,
    renderConfig: PropTypes.object.isRequired,
};

ColoredItemsLegend.defaultProps = {
    icon: 'circle',
};
